// Official Brivio brand logo. Horizontal lockup on light surfaces;
// on dark surfaces (light=true) it sits on a white chip so the navy wordmark stays crisp.
export const Logo = ({ light = false, className = "", iconOnly = false, size = "default" }) => {
  const h = size === "lg" ? "h-[50px] md:h-[68px]" : "h-9 md:h-10";
  if (iconOnly) {
    return (
      <span className={`inline-flex items-center ${className}`} data-testid="brivio-logo">
        <img
          src="/brand/icon-1024.png"
          alt="Brivio"
          className="h-9 w-9 object-contain"
          data-testid="brivio-logo-icon"
        />
      </span>
    );
  }

  const img = (
    <img
      src="/brand/logo-horizontal-transparent.png"
      alt="Brivio"
      className={`${h} w-auto object-contain`}
      data-testid="brivio-logo-img"
    />
  );

  if (light) {
    return (
      <span
        className={`inline-flex items-center rounded-xl bg-white px-3 py-2 shadow-sm ${className}`}
        data-testid="brivio-logo"
      >
        <img
          src="/brand/logo-header.png"
          alt="Brivio"
          className="h-9 md:h-10 w-auto object-contain"
          data-testid="brivio-logo-img"
        />
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center ${className}`} data-testid="brivio-logo">
      {img}
    </span>
  );
};
